import { gql } from '@apollo/client';

export const DELETE_ROUTE_PLANNING_TEMPLATE = gql`
    mutation DeleteRoutePlanningTemplate($id: Long!) {
        deleteRoutePlanningTemplate(id: $id)
    }
`;

export interface DeleteRoutePlanningTemplateResponse {
    deleteRoutePlanningTemplate: boolean;
}

export interface DeleteRoutePlanningTemplateVariables {
    id: number;
}
